import logo from './logo.svg';
import './App.css';
import React, { useEffect, useState } from 'react';
import WOW from 'wowjs';
import 'animate.css/animate.css';
import Router from './router';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import StickyPopupAd from './components/ads/StickyPopupAd';
import StickyHeaderAd from './components/ads/StickyHeaderAd';

function App() {
  useEffect(() => {
    const wow = new WOW.WOW({
        live: false
    });
    wow.init();
}, []);

  return (
    <>
    <ToastContainer />
    {/* Sticky Header Ad - appears on every page at the top */}
    <StickyHeaderAd positionId={1} />
    {/* Main content wrapper - adds top margin to all pages to prevent content from being hidden */}
    <div style={{ marginTop: '30px' }}>
      <Router />
    </div>
    {/* Sticky Popup Ad - appears on every page in bottom right */}
    <StickyPopupAd positionId={4} />
    </>
  );
}

export default App;
